








































import {Component, Vue, Watch} from "vue-property-decorator";

import {Getter, Action} from "vuex-class";

import DefaultLayout from "@/layouts/DefaultLayout.vue";
import ResetPasswordForm from "@/components/Auth/ResetPasswordForm.vue";
import Card from "@/components/Card/Card.vue";


const authNamespace: string = "auth";
@Component({
  components: {Card, ResetPasswordForm, DefaultLayout}
})
export default class ResetPassword extends Vue {

  public name: string = "ResetPassword";

  @Action('resetPassword', {namespace: authNamespace}) resetPassword: any;

  private token: string = '';
  private status: string = '';
  private error: any = null;
  private validationErrors: any = null;

  public onSubmit(data: object): void {

    data = {
      ...data,
      token: this.$route.query.token,
      test: 'fjasl'
    };

    this.resetPassword(data).then((response: any) => {

      this.status = response.data.message;
    }).catch((error: any) => {

      this.error = error.response.data;

      if (error.response.status === 422) {

        this.validationErrors = error.response.data.errors;

      }

    });

  }

  private errormsg(): string {
    return this.error ? this.error.data.error : '';
  }

  created() {



  }

}
